// From http://www.jeremymartin.name/projects.php?project=jTruncate
// The string to be truncated is split into two parts - a leading part
// that's displayed and a trailing part that's hidden and shown when
// more is clicked.
//
// NOTE: The trailing part has the final character trimmed (probably
// on assumption that there's always a trailing carriage return).
//
// PLEASE NOTE: We modified this to use slideUp and slideDown
// instead of show() and hide(). The UX team requested that the animation
// be modified so that it has a smoother, sliding effect.
// This is no longer maintained by original author, and is 60 lines of code,
// so it seemed reasonable to modify the vendor code vs porting all the PDP
// and browse page components that use jtruncate to React. If you find
// yourself needing to upgrade this component, consider porting the
// functionality to Minted UI instead.
(function($){
  $.fn.jTruncate = function(options) {

    var defaults = {
      length: 300,
      minTrail: 20,
      moreText: "more",
      lessText: "less",
      ellipsisText: "...",
      moreAni: "fast",
      lessAni: "fast"
    };

    var options = $.extend(defaults, options);

    return this.each(function() {
      obj = $(this);
      var body = obj.html();
      if(body.length > options.length + options.minTrail) {
        var splitLocation = body.indexOf(' ', options.length);
        if(splitLocation != -1) {
          // truncate tip
          var splitLocation = body.indexOf(' ', options.length);
          var str1 = body.substring(0, splitLocation);
          var str2 = body.substring(splitLocation, body.length - 1);
          obj.html(str1 + '<span class="truncate_ellipsis">' + options.ellipsisText +
            '</span>' + '<span class="truncate_more">' + str2 + '</span>');
          obj.find('.truncate_more').css("display", "none");

          // insert more link
          obj.append('<a href="#" class="truncate_more_link">' + options.moreText + '</a>');

          // set onclick event for more/less link
          var moreLink = $('.truncate_more_link', obj);
          var moreContent = $('.truncate_more', obj);
          var ellipsis = $('.truncate_ellipsis', obj);
          moreLink.click(function() {
            if (moreLink.text() == options.moreText) {
              moreLink.text(options.lessText);
              ellipsis.css("display", "none");
              moreContent.fadeIn(options.moreAni);
            } else {
              moreLink.text(options.moreText);
              ellipsis.css("display", "inline");
              moreContent.fadeOut(options.lessAni);
            }
            return false;
          });
        }
      } // end if

    });
  };
})(jQuery);